package com.milta.core.localization.translations.fr

import com.milta.core.localization.AuthStrings

internal val Auth = AuthStrings(
    login = "Connexion",
    logout = "Déconnexion",
    email = "Email",
    password = "Mot de passe",
    showPassword = "Afficher",
    hidePassword = "Masquer",
    roleSelectionTitle = "Créer un compte",
    roleSelectionSubtitle = "Choisissez le type de compte qui correspond à votre profil",
    roleDriverTitle = "Je suis chauffeur - livreur",
    roleDriverDescription = "Je conduis un véhicule de transport ou de livraison et je souhaite optimiser mes tournées",
    roleDriverTag1 = "Optimiser mes tournées",
    roleDriverTag2 = "Bons plans Milta sur ma route",
    roleEnterpriseTitle = "Je suis une entreprise",
    roleEnterpriseDescription = "J'ai un numéro de TVA et je gère une flotte de véhicules et une équipe de chauffeurs",
    roleEnterpriseTag1 = "Gestion de flotte",
    roleEnterpriseTag2 = "Suivi équipes",
    continueButton = "Continuer",
    registerFormTitle = "Finalisez l'inscription",
    registerFormSubtitle = "Confirmez votre numéro de téléphone pour activer votre compte.",
    registerFormSubtitleEnterprise = "Renseignez votre organisation et un numéro de téléphone pour activer votre compte.",
    googleAccountConnected = "Compte Google connecté",
    appleAccountConnected = "Compte Apple connecté",
    firstName = "Prénom",
    lastName = "Nom",
    phoneNumber = "Numéro de téléphone",
    phoneNumberHelper = "Saisissez le numéro de votre choix.",
    phoneNumberOtpInfo = "Un code de vérification vous sera envoyé par SMS pour confirmer ce numéro.",
    registerButton = "Recevoir un code de vérification",
    passwordHint = "Au moins 8 caractères",
    registerSuccess = "Compte créé avec succès",
    errorEmailConflict = "Cette adresse email est déjà utilisée",
    errorPhoneConflict = "Ce numéro de téléphone est déjà utilisé",
    errorPhoneChangeCooldown = "Vous ne pouvez changer de numéro qu'une fois tous les 30 jours",
    errorGeneric = "Connexion impossible. Vérifiez votre réseau et réessayez.",
    errorFirstNameRequired = "Veuillez entrer votre prénom",
    errorFirstNameTooLong = "Le prénom ne peut pas dépasser 100 caractères",
    errorLastNameRequired = "Veuillez entrer votre nom",
    errorLastNameTooLong = "Le nom ne peut pas dépasser 100 caractères",
    errorPhoneTooLong = "Le numéro de téléphone ne peut pas dépasser 20 caractères",
    errorOAuthAccountExists = "Ce compte est déjà lié à un autre compte Milta. Essayez de vous connecter.",
    errorOAuthTokenInvalid = "Votre session a expiré. Veuillez réessayer de vous connecter.",
    loginTitle = "Connexion",
    loginTabPassword = "Mot de passe",
    loginTabPhone = "Téléphone",
    loginButton = "Se connecter",
    forgotPassword = "Mot de passe oublié ?",
    sendCodeButton = "Envoyer le code",
    otpTitle = "Entrez le code",
    otpSubtitle = "Nous avons envoyé un code à 6 chiffres au",
    otpVerifyButton = "Vérifier",
    otpResend = "Renvoyer un code",
    otpResendPrefix = "Code non reçu ?",
    otpWrongNumber = "Mauvais numéro ?",
    otpModifyLink = "Modifier",
    forgotPasswordTitle = "Mot de passe oublié",
    forgotPasswordSubtitle = "Entrez votre adresse email pour recevoir un lien de réinitialisation",
    forgotPasswordButton = "Envoyer le lien",
    forgotPasswordSuccess = "Vérifiez votre boîte mail",
    resetPasswordTitle = "Nouveau mot de passe",
    resetPasswordSubtitle = "Choisissez un nouveau mot de passe pour votre compte",
    resetPasswordNewLabel = "Nouveau mot de passe",
    resetPasswordConfirmLabel = "Confirmez le mot de passe",
    resetPasswordButton = "Réinitialiser le mot de passe",
    resetPasswordSuccess = "Mot de passe réinitialisé. Vous pouvez maintenant vous connecter.",
    errorPasswordTooShort = "Le mot de passe doit contenir au moins 8 caractères",
    errorPasswordTooLong = "Le mot de passe ne peut pas dépasser 128 caractères",
    errorPasswordMismatch = "Les mots de passe ne correspondent pas",
    errorTokenInvalid = "Ce lien de réinitialisation est invalide ou a expiré. Demandez-en un nouveau.",
    errorEmailInvalid = "Veuillez entrer une adresse e-mail valide",
    errorPhoneRequired = "Veuillez entrer un numéro de téléphone",
    errorInvalidCredentials = "Email ou mot de passe incorrect. Utilisez « Mot de passe oublié ? » si besoin.",
    errorInvalidOtp = "Code incorrect. Vérifiez votre SMS ou demandez un nouveau code.",
    errorExpiredOtp = "Code expiré. Demandez un nouveau code.",
    errorTooManyAttempts = "Trop de tentatives incorrectes. Réessayez dans quelques minutes.",
    errorResendLimit = "Trop de demandes de renvoi. Réessayez dans quelques minutes.",
    otpResendIn = "Renvoyer dans %d s",
    otpAttemptsLeft = "%d essais restants",
    loginGreeting = "Bon retour !",
    loginSubtitle = "Connectez-vous à votre compte Milta",
    loginSmsOption = "Recevoir un code SMS",
    noAccount = "Pas encore de compte ?",
    signUp = "S'inscrire",
    organizationName = "Nom de l'organisation",
    organizationNameRequired = "Veuillez entrer le nom de l'organisation",
    registerNextButton = "Suivant",
    passwordConfirm = "Confirmer le mot de passe",
    passwordRuleUpper = "Une lettre majuscule",
    passwordRuleDigit = "Un chiffre",
    passwordRuleSpecial = "Un caractère spécial",
    alreadyHaveAccount = "J'ai déjà un compte — Connexion",
)
